import { SuspenseContentWrapper } from '@euler/app/components/SuspenseContentWrapper';
import { useAIAssistantForPage } from '@euler/app/components/ai/pageContext';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import {
  useIsMobileLayout,
  useIsTabletLandscapeLayout,
} from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { InspectionScreenContent } from './components/InspectionScreenContent';
import { InspectionScreenContentForIpad } from './components/InspectionScreenContent.iPad';
import { TaskInspectionProps } from './functions/useTaskInspection';
import { SiteInspectionNavigatorContextProvider } from './site-inspection/SiteInspectionNavigator';

const kAlwaysUseSidePanelNavigatorForIpad = true;

export const InspectionScreen = wrapNavigatorScreen(
  (props: TaskInspectionProps) => {
    const { taskNo } = useTaskContext();
    useAIAssistantForPage('inspection', { taskNo, flowId: props.flowId });
    const isMobile = useIsMobileLayout();
    const isLandscape = useIsTabletLandscapeLayout();
    const mode =
      !isMobile && (isLandscape || kAlwaysUseSidePanelNavigatorForIpad)
        ? 'sidepanel'
        : 'bottomsheet';
    return (
      <SuspenseContentWrapper
        ErrorBoundaryComponent={null}
        contentContainerStyle={{
          justifyContent: 'center',
        }}
      >
        <SiteInspectionNavigatorContextProvider navigatorContainerType={mode}>
          {mode === 'sidepanel' ? (
            <InspectionScreenContentForIpad {...props} />
          ) : (
            <InspectionScreenContent {...props} />
          )}
        </SiteInspectionNavigatorContextProvider>
      </SuspenseContentWrapper>
    );
  },
  { headerShown: false },
);
